
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { UsersRound, MessageSquare } from "lucide-react";
import { Club } from "@/hooks/useClubs";
import { Link } from "react-router-dom";

interface ClubCardProps {
  club: Club;
  onJoinClick: () => void;
  isJoining: boolean;
}

const ClubCard: React.FC<ClubCardProps> = ({ club, onJoinClick, isJoining }) => {
  return (
    <Card className="transition-shadow hover:shadow-md">
      <CardHeader>
        <div className="flex justify-between items-start">
          <CardTitle className="text-xl">{club.name}</CardTitle>
          <Badge>{club.category}</Badge>
        </div>
      </CardHeader>
      <CardContent>
        <CardDescription className="line-clamp-3 mb-4">
          {club.description}
        </CardDescription>
        <div className="flex items-center justify-between">
          <div className="flex items-center text-sm text-muted-foreground">
            <UsersRound className="h-4 w-4 mr-2" />
            <span>{club.member_count || 0} members</span>
          </div>
          <Link to={`/clubs/${club.id}`} className="text-sm text-muted-foreground hover:text-primary flex items-center">
            <MessageSquare className="h-4 w-4 mr-1" />
            <span>Discussions</span>
          </Link>
        </div>
      </CardContent>
      <CardFooter>
        <Button 
          className="w-full" 
          variant={club.is_member ? "outline" : "default"}
          onClick={onJoinClick}
          disabled={isJoining}
        >
          {isJoining ? (
            "Processing..."
          ) : club.is_member ? (
            "Leave Club"
          ) : (
            "Join Club"
          )}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ClubCard;
